import { render, staticRenderFns } from "./ServiceSupermarket.vue?vue&type=template&id=00726de0&scoped=true&"
import script from "./ServiceSupermarket.vue?vue&type=script&lang=js&"
export * from "./ServiceSupermarket.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSupermarket.vue?vue&type=style&index=0&id=00726de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00726de0",
  null
  
)

export default component.exports